export const Divider = () => {
  return (
    <div className="flex items-center gap-4 text-gray-700">
      <div className="h-px flex-1 bg-gray-300" />
      <span>or</span>
      <div className="h-px flex-1 bg-gray-300" />
    </div>
  )
}
